import { theme } from 'containers/GlobalStyle'
import React from 'react'
import styled from 'styled-components'
import ProductImage from 'theme/atoms/ProductImage'
import Price, * as Prices from 'theme/atoms/Price'
import Link from 'theme/atoms/Link'
import { FiArrowRight } from 'react-icons/fi'
import * as gt from 'utils/productShapeTypes'
import useTranslations from 'hooks/useTranslations'
import Spinner from 'theme/atoms/Spinner'

export default function CustomTailorProduct(props: {
  title: string | null
  brand: string | null
  imageUrl: string | null
  prices: gt.ProductPriceDefinition | null
  containerId: string | null
  sku: string | null
  isLoading?: boolean
}) {
  const t = useTranslations<'templates-PDP'>()

  return (
    <Wrapper
      className="CustomTailorProduct"
      data-cy-collection="CustomTailorProduct"
    >
      {props.isLoading && (
        <div data-cy-state="show-loading-spinner" className="spinner-container">
          <Spinner size="medium"></Spinner>
        </div>
      )}
      {!props.isLoading && (
        <Link
          data-cy-state="show-product-hint"
          className="link-wrapper"
          to={`/pdp/${props.containerId}/?sku=${props.sku}`}
        >
          <div className="head-line">{t('to_measure_item_available')}</div>
          <div className="content-box">
            <div className="image-container">
              <div className="image-background">
                <ProductImage
                  img={{
                    url: props.imageUrl || '',
                    classes: ['ASSET_FS']
                  }}
                  size="xs"
                  alt={'image'}
                ></ProductImage>
              </div>
            </div>
            <div className="info-container">
              <div className="brand">{props.brand}</div>
              <div className="title">{props.title}</div>
              {props.prices && (
                <div
                  data-cy-state="show-product-price"
                  className="price-container"
                >
                  <div className="price">
                    {/* {props.prices.productCheapestPiecePriceNet &&
                      props.prices.productMostexpensivePiecePriceNet &&
                      props.prices.productCheapestPiecePriceNet <
                        props.prices.productMostexpensivePiecePriceNet && (
                        <>{t('price_range_from')} </>
                      )} */}
                    <Price prices={props.prices} logic="piece"></Price>
                  </div>
                </div>
              )}
              <div className="unit">{t('per_squaremeter_text')}</div>
              <div className="product-link">
                {t('redirect_to_product')} <FiArrowRight />
              </div>
            </div>
          </div>
        </Link>
      )}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  background-color: ${theme.colors.shade.primaryUltraBright};
  padding: 1.25rem;
  > .link-wrapper {
    > .head-line {
      padding-bottom: 1.25rem;
      color: ${theme.colors.b0};
      ${theme.ty('rc-s', 'bold')}
      @media (min-width: ${theme.ms.MD}px) {
        ${theme.ty('rc-base', 'bold')}
      }
    }
    > .content-box {
      display: flex;
      flex-direction: row;
      gap: ${theme.spacing('m')};
      > .image-container {
        > .image-background {
          background-color: ${theme.colors.white};
          height: 6.25rem;
          width: 6.25rem;
          > .ProductImage {
            scale: 80%;
          }
        }
      }
      > .info-container {
        width: 100%;
        position: relative;
        height: 7.5rem;
        @media (min-width: ${theme.ms.MD}px) {
          height: 9.375rem;
        }
        > .brand {
          color: ${theme.colors.shade.b2};
          ${theme.ty('r-xs', 'bold')}
          @media (min-width: ${theme.ms.MD}px) {
            ${theme.ty('r-s', 'bold')}
          }
        }
        > .title {
          overflow: hidden;
          margin: 0 auto;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow-x: hidden;
          text-overflow: ellipsis;
          height: 2lh;
          ${theme.ty('r-s')}
          @media (min-width: ${theme.ms.MD}px) {
            ${theme.ty('r-base')}
          }
        }
        > .price-container {
          padding-top: ${theme.spacing('xs')};
          > .price {
            ${theme.ty('r-s', 'bold')}
            @media (min-width: ${theme.ms.MD}px) {
              ${theme.ty('r-base', 'bold')}
            }
          }
        }
        > .unit {
          color: ${theme.colors.shade.b2};
          padding-bottom: ${theme.spacing('xs')};
          ${theme.ty('r-xs')}
          @media (min-width: ${theme.ms.MD}px) {
            ${theme.ty('r-s')}
          }
        }
        > .product-link {
          display: flex;
          align-items: center;
          gap: ${theme.spacing('xs')};
          ${theme.ty('rc-s', 'bold')}
          @media (min-width: ${theme.ms.MD}px) {
            ${theme.ty('rc-base', 'bold')}
          }
        }
      }
    }
  }

  > .spinner-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 10.125rem;
    @media (min-width: ${theme.ms.MD}px) {
      height: 12rem;
    }
  }
`
